import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';

const quicksort = async (a, lo, hi, delayController) => {
  if (lo < hi) {
    const p = await partition(a, lo, hi, delayController);
    await quicksort(a, lo, p, delayController);
    await quicksort(a, p + 1, hi, delayController)
  }
}
const partition = async (a, lo, hi, delayController) => {
  const pivot = a[lo];
  let i = lo - 1;
  let j = hi + 1;
  while (true) {
    do {
      i += 1;
      await delayController.delay();
    } while (a[i] < pivot);

    do {
      j = j - 1;
      await delayController.delay();
    } while (a[j] > pivot);

    if (i >= j) {
      break;
    }
    await delayController.delay();
    swap(a, i, j)
  }
  return new Promise((r) => {
    r(j)
  })
}
export default class QuicksortAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort (a) {
    quicksort(a, 0, a.length - 1, this.delayController)
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/quicksort.js